<template>
  <b-container
    fluid>
    <b-form
      ref="form"
      :validated="validated"
      novalidate
      @submit.prevent="onSubmit"
      @reset.prevent="$emit('cancel')">
      <b-form-row class="mb-2">
        <b-col class="text-muted">
          Promotions can only be scheduled within the next 30 days.
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group
            label="Scheduled Promotion Date"
            invalid-feedback="Scheduled Promotion Date is required">
            <b-input-group>
              <date-time-picker
                v-model="date"
                :time-zone="timeZone"
                :config-override="{ minDate: minDate, maxDate: maxDate }"
                required />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>
      <div class="d-flex justify-content-end mt-4">
        <b-btn
          type="reset"
          variant="search"
          class="xl-wide mr-2">
          Cancel
        </b-btn>
        <b-btn
          type="submit"
          variant="primary"
          class="xl-wide ml-2">
          Submit
        </b-btn>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import moment from "moment-timezone"
import DateTimePicker from "@/components/DateTimePicker"

export default {
  name: "ConfigScheduleRequestForm",
  components: {
    DateTimePicker,
  },
  data() {
    return {
      date: null,
      minDate: moment(),
      maxDate: moment().add(30, 'day'),
      validated: false,
      timeZone: moment.tz.guess(true).name,
    }
  },
  methods: {
    onSubmit(evt) {
      this.validated = true

      const form = evt.target
      if (!form.checkValidity()) {
        this.$alert.warning(
            "Scheduling request contains an error. Please fix before submitting",
        )
        return
      }
      this.$emit("on-submit", this.date)
    },
  },
}
</script>

<style scoped>
</style>
